var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticClass: "grid row-cols-2 row-cols-xl-4" },
    _vm._l(_vm.products, function (product, idx) {
      return _c(
        "a",
        { key: idx, staticClass: "col" },
        [
          _c("frame-product-extra", {
            staticClass: "mb-3",
            attrs: { product: product },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }